import {cleanObject} from '../../utils/utilities';
import {events} from '../events';

/**
 * Get symbol MPID clearing configurations
 */
export const getSymbolMpidClearing = (params = {}) => ({
    types: [
        events.SYMBOL_MPID_CLEARING_GET,
        events.SYMBOL_MPID_CLEARING_SUCCESS,
        events.SYMBOL_MPID_CLEARING_ERROR
    ],
    payload: {
        client: 'cdmMw',
        request: {
            url: 'api/symbol-mpid-clearing',
            params: cleanObject({
                userCrd: params.userCrd,
                mpid: params.mpid,
                symbol: params.symbol,
                clearingNumber: params.clearingNumber,
                offset: params.offset,
                limit: params.limit
            })
        }
    }
});

/**
 * Create or update symbol MPID clearing configurations
 * @param {Object} params - Request parameters
 * @param {number} params.userCrd - User CRD number
 * @param {Array<Object>} params.configurations - Array of configurations to create/update
 * @param {string} params.configurations[].mpid - MPID
 * @param {string} params.configurations[].symbol - Symbol
 * @param {string} params.configurations[].clearingNumber - Clearing number
 */
export const createSymbolMpidClearing = ({userCrd, configurations}) => ({
    types: [
        events.SYMBOL_MPID_CLEARING_CREATE,
        events.SYMBOL_MPID_CLEARING_CREATE_SUCCESS,
        events.SYMBOL_MPID_CLEARING_CREATE_ERROR
    ],
    payload: {
        client: 'cdmMw',
        request: {
            method: 'POST',
            url: '/api/symbol-mpid-clearing',
            params: {userCrd},
            data: configurations
        }
    }
});

/**
 * Delete symbol MPID clearing configurations
 * @param {Object} params - Request parameters
 * @param {number} params.userCrd - User CRD number
 * @param {Array<Object>} params.configurations - Array of configurations to delete
 * @param {string} params.configurations[].mpid - MPID
 * @param {string} params.configurations[].symbol - Symbol
 * @param {string} params.configurations[].clearingNumber - Clearing number
 */
export const deleteSymbolMpidClearing = ({userCrd, configurations}) => ({
    types: [
        events.SYMBOL_MPID_CLEARING_DELETE,
        events.SYMBOL_MPID_CLEARING_DELETE_SUCCESS,
        events.SYMBOL_MPID_CLEARING_DELETE_ERROR
    ],
    payload: {
        client: 'cdmMw',
        request: {
            method: 'DELETE',
            url: '/api/symbol-mpid-clearing',
            params: {userCrd},
            data: configurations
        }
    }
});
